import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'pdf',
})
export class PdfPipe implements PipeTransform {
  url: string = environment.apiURL;

  transform(value: unknown, ...args: unknown[]): string {
    const name = String(value ?? '').split(/[\\/]/).pop() || '';
    return `${this.url}pdf/${encodeURIComponent(name)}`;
  }
}
